module.exports = __webpack_public_path__ + "img/horiz_logo_ii.0b98b1e7.png";